module.exports = __webpack_public_path__ + "static/img/tc-icon-9.0da8413.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/tc-icon-9.png
// module id = 8+yF
// module chunks = 1